<div class="container">
    <div class="row justify-content-center">
        <div class="box col-12 col-xl-9">
            <div class="box__cont">
                <div class="box__title">
                    <h1>SECURITY</h1>
                </div>
                <div class="box__article">
                    <p>To protect the personal and account information of our clients, ATRAM employs extensive physical, electronic, and procedural security controls, regularly adapting them as technology and threats evolve. Listed below are just a few of the measures we take:</p>
                </div>
                <div class="box__article">
                    <p><b>Online Account Access</b></p>
                    <p>A representative’s valid User ID and Password allows encrypted and secure access to his/her account on behalf of the partner.</p>
                </div>
                <div class="box__article">
                    <p><b>Partners Account Validation</b></p>
                    <p>Whenever a representative contacts ATRAM whether in our office or by phone or email, we verify his/her identity before granting access to his/her account.</p>
                </div>
                <div class="box__article">
                    <p><b>Mobile Number Verification</b></p>
                    <p>Whenever a representative attempts to access his/her account, either via registration or log-in, a One-Time-Password (OTP) will be sent to their designated mobile number via SMS text message, then will be entered by the representative upon every attempt.</p>
                </div>
                <div class="box__article">
                    <p><b>Order Repository</b></p>
                    <p>Whenever a file has been uploaded, it will be encrypted and stored on the ATRAM's cloud storage.</p>
                </div>
                <div class="box__article">
                    <p><b>Firewalls</b></p>
                    <p>To block unauthorized access, all our computer systems are protected by firewalls and electronic barriers that prevent unauthorized access to our networks.</p>
                </div>
                <div class="box__article">
                    <p><b>Encryption</b></p>
                    <p>ATRAM employs some of the strongest methods of encryption commercially available. All online activity involving personal or sensitive information is encrypted from the point it leaves your computer until it enters our systems. For your general online security, be sure the letter "s" appears after the syntax "http" at the beginning of the URL address before entering any sensitive information, indicating the site is secure (e.g., https://www.ATRAM.com.ph). Another sign that a website is secure is a padlock icon shown in the security indicator/section of your browser. </p>
                </div>
                <div *ngIf="localStorageService.get('authorized') === null" class="text-right">
                    <atram-button label="Back to Sign-in"
                                    buttonType="default"
                                    componentClass="btn-submit"
                                    (on-click)="goBack()">
                    </atram-button>
                </div>
            </div>
        </div>
    </div>
</div>